<template>
  <transition
      name="transition-fade-fast"
      mode="out-in"
  >
    <div
        v-if="!loading"
        data-image
        :style="{ 'background': `url('${src}') center center / cover` }"
        :class="classListImage"
    />
    <Loader
        v-else
        data-thumbnail-loader
        :visible="true"
        class="absolute top-50 left-50 -translate-center text-blue-500"
    />
  </transition>
</template>

<script>
import axios from 'axios'
import Loader from '@vuedir/components/Loader'

/**
 * LazyImage.vue
 */
export default {
  components: {
    Loader,
  },

  props: {
    // eslint-disable-next-line vue/require-prop-types
    image: {
      required: true,
    },
  },

  data () {
    return {
      loading: true,
      src: '',
    }
  },

  computed: {
    classListImage () {
      return [
        'transition-all w-full h-full',
      ]
    },
  },

  mounted () {
    this.src = this.image.default || this.image
    this.preload(this.src, this.handleLoad)
  },

  methods: {
    async load () {
      try {
        await axios.head(this.src)

        this.preload(this.src, this.handleLoad)
      } catch (error) {
        this.handleError()
      }
    },

    preload (image, onLoadCallback) {
      let img = new Image()
      img.onload = onLoadCallback
      img.src = image
    },

    handleLoad () {
      this.loading = false
    },

    handleError () {
      this.$emit('error')
    },
  },
}
</script>
